<template>
  <TableLayout :permissions="['business:goodssku:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="主键" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商品编码（关联goods表）" prop="goodsId">
        <el-input v-model="searchForm.goodsId" placeholder="请输入商品编码（关联goods表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="SKU编码（关联sku表）" prop="skuId">
        <el-input v-model="searchForm.skuId" placeholder="请输入SKU编码（关联sku表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="sku组合名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入sku组合名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="sku图片" prop="imgurl">
        <el-input v-model="searchForm.imgurl" placeholder="请输入sku图片" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="展示价格" prop="showPrice">
        <el-input v-model="searchForm.showPrice" placeholder="请输入展示价格" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="销售价格（元/咖豆）" prop="price">
        <el-input v-model="searchForm.price" placeholder="请输入销售价格（元/咖豆）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="库存量" prop="stock">
        <el-input v-model="searchForm.stock" placeholder="请输入库存量" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="商品重量(kg)" prop="weight">
        <el-input v-model="searchForm.weight" placeholder="请输入商品重量(kg)" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态0上架 1下架" prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入状态0上架 1下架" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:goodssku:create', 'business:goodssku:delete']">
        <li><el-button type="primary" @click="$refs.operaGoodsSkuWindow.open('新建商品SKU规格组信息表')" icon="el-icon-plus" v-permissions="['business:goodssku:create']">新建</el-button></li>
        <li><el-button type="danger"  @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:goodssku:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="goodsId" label="商品编码（关联goods表）" min-width="100px"></el-table-column>
        <el-table-column prop="skuId" label="SKU编码（关联sku表）" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="sku组合名称" min-width="100px"></el-table-column>
        <el-table-column prop="imgurl" label="sku图片" min-width="100px"></el-table-column>
        <el-table-column prop="showPrice" label="展示价格" min-width="100px"></el-table-column>
        <el-table-column prop="price" label="销售价格（元/咖豆）" min-width="100px"></el-table-column>
        <el-table-column prop="stock" label="库存量" min-width="100px"></el-table-column>
        <el-table-column prop="weight" label="商品重量(kg)" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态0上架 1下架" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:goodssku:update', 'business:goodssku:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaGoodsSkuWindow.open('编辑商品SKU规格组信息表', row)" icon="el-icon-edit" v-permissions="['business:goodssku:update']">编辑</el-button>
            <el-button type="text"  style="color: red;" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:goodssku:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaGoodsSkuWindow ref="operaGoodsSkuWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaGoodsSkuWindow from '@/components/business/OperaGoodsSkuWindow'
export default {
  name: 'GoodsSku',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaGoodsSkuWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        goodsId: '',
        skuId: '',
        name: '',
        imgurl: '',
        showPrice: '',
        price: '',
        stock: '',
        weight: '',
        status: ''
      }
    }
  },
  created () {
    this.config({
      module: '商品SKU规格组信息表',
      api: '/business/goodsSku',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
